import React, { useState, useEffect } from 'react'
import { AXIOS } from '../api'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDropzone } from 'react-dropzone'
import { ChromePicker } from 'react-color'
import { useForm } from 'react-hook-form'
import _, { values } from 'lodash'
import Switch from "react-switch"
import ItemsList from './common/ItemsList'
import { TwitterPicker } from 'react-color'

import { Title, Picture, Heading, Icons, PictureItem } from './common/Themes'
import { setLoading, setFetch } from '../redux/actions'



const UpdateOffre = () => {

    const dispatch = useDispatch()
    const { activites, offres, articles, taches, accessoires } = useSelector(state => state.fetch)
    const { fetch } = useSelector(state => state.config)

    const [offre, setOffre] = useState({})
    const [name, setName] = useState('')
    const [strings, setStrings] = useState({ string_1: '', string_2: '' })
    const [articlesFill, setArticlesFill] = useState([]);
    const [articlesFillCodebarre, setArticlesFillCodebarre] = useState([]);
    const [selectedArticle, setSelectedArticle] = useState(null);
    const [file, setFile] = useState()
    const [fileBorne, setFileBorne] = useState()
    const [fileAds, setFileAds] = useState()
    const [imageURL, setImageURL] = useState('')
    const [color, setColor] = useState({ hex: '#FF5C00', rgb: { r: 245, g: 68, b: 46, a: .8 } })
    const history = useHistory()

    const location = useLocation()
    const [, type, oid] = location.pathname.split('/')

    const [relatedPack, setRelatedPack] = useState('');
    const [relatedPackInputValue, setRelatedPackInputValue] = useState('');
    const [relatedAccessoires, setRelatedAccessoires] = useState('');
    const [relatedAccessoiresInputValue, setRelatedAccessoiresInputValue] = useState('');

    const [idTaches, setIdTaches] = useState([]);
    const [cidAccessoires, setCidAccessoires] = useState([]);

    const [web, setWeb] = useState(true)
    const [booking, setBooking] = useState(false)
    const [borne, setBorne] = useState(true)
    const [planning, setPlanning] = useState(true)
    const [promotion, setPromotion] = useState(true)

    const [primaryColor, setPrimaryColor] = useState('#000')
    const [secondaryColor, setSecondaryColor] = useState('#000')
    const [backgroundColor, setBackgroundColor] = useState('#000')

    useEffect(() => {
        setArticlesFill(articles);
        setArticlesFillCodebarre(articles.filter(({ category }) => category === 8));
        setIdTaches(taches.map(({ id }) => id));
        setCidAccessoires(accessoires.map(({ cid }) => cid));
    }, [articles, taches, accessoires]);

    useEffect(() => {
        const offre = offres.filter(item => item.oid === oid)[0]
        console.log('⚗️ CURRENT OFFRE: ', offre)
        setOffre(offre)
        setName(offre?.name)
        setColor({ hex: offre?.color })

        if (!!offre?.strings) {
            try {
                const STRINGS = offre?.strings?.replace(/\\n/g, '\n').replace(/\\/g, '');
                setStrings(JSON.parse(STRINGS.trim()))

            } catch (error) {
                console.error("Failed to parse JSON:", error.message);
            }
        }

        setImageURL(`${process.env.REACT_APP_SITE_MARCHAND}${offre?.image}`)
        setImageBorne(`${process.env.REACT_APP_SITE_MARCHAND}${offre?.image_borne}`)
        setImageAds(`${process.env.REACT_APP_SITE_MARCHAND}${offre?.image_ads}`)

        setWeb(offre?.web)
        setBooking(offre?.booking)
        setBorne(offre?.borne)
        setPlanning(offre?.planning)
        setPromotion(offre?.promotion)

        setRelatedPack(offre?.plannings)
        setRelatedAccessoires(offre?.equipements)

        setSelectedArticle(offre?.article)
        setPrimaryColor(offre?.colors?.primary)
        setSecondaryColor(offre?.colors?.secondary)
        setBackgroundColor(offre?.colors?.background)
    }, [offres, oid, setOffre, setName, setColor])

    const { handleSubmit, register, errors, getValues, watch } = useForm()

    // DROPZONE IMAGE --------------------------------------------------------------------------------------------------------
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: acceptedFiles => {
            acceptedFiles.map(file => {
                Object.assign(file, {
                    preview: URL.createObjectURL(file)
                })
                setFile(acceptedFiles[0])
                const reader = new FileReader();
                reader.onload = (event) => {
                    setImageURL(event.target.result);
                };
                reader.readAsDataURL(file);
            });
        }
    });

    const [imageBorne, setImageBorne] = useState(`${process.env.REACT_APP_SITE_MARCHAND}/img/default_image_borne.png`);
    const fileInputRef = React.useRef(null);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            setFileBorne(file)
            reader.onloadend = () => {
                setImageBorne(reader.result);  // Set the base64 image as state
            };
            reader.readAsDataURL(file);  // Read the file as data URL
        }
    };

    const [imageAds, setImageAds] = useState('/img/default_image.png');
    const fileInputAdsRef = React.useRef(null);

    const handleImageAdsChange = (e) => {
        const file = e.target.files[0];

        console.log(file)
        if (file) {
            const reader = new FileReader();
            setFileAds(file)
            reader.onloadend = () => {
                setImageAds(reader.result);  // Set the base64 image as state
            };
            reader.readAsDataURL(file);  // Read the file as data URL
        }
    };

    const handleUploadClick = () => {
        fileInputRef.current.click();  // Trigger the hidden file input
    };
    const handleUploadAdsClick = () => {
        fileInputAdsRef.current.click();  // Trigger the hidden file input
    };

    const handleChangeRelatedPack = (e) => {
        // setRelatedPack(`${relatedPack},${e.target.value}`)
        if (idTaches.includes(e.target.value * 1)) {
            if (relatedPack?.length > 0) setRelatedPack(`${relatedPack},${e.target.value}`);
            else setRelatedPack(e.target.value);
        }
        setRelatedPackInputValue(e.target.value);
    };
    const deleteRelatedPack = (id) => {
        if (relatedPack.includes(`${id},`)) setRelatedPack(relatedPack.replace(`${id},`, ''));
        else if (relatedPack.includes(`,${id}`)) setRelatedPack(relatedPack.replace(`,${id}`, ''));
        else setRelatedPack(relatedPack.replace(`${id}`, ''));
    };

    const handleChangeRelatedAccessoires = (e) => {
        if (cidAccessoires.includes(e.target.value)) {
            if (relatedAccessoires?.length > 0) setRelatedAccessoires(`${relatedAccessoires},${e.target.value}`);
            else setRelatedAccessoires(e.target.value);
        }
        setRelatedAccessoiresInputValue(e.target.value);
    };
    const deleteRelatedAccessoires = (cid) => {
        if (relatedAccessoires.includes(`${cid},`)) setRelatedAccessoires(relatedAccessoires.replace(`${cid},`, ''));
        else if (relatedAccessoires.includes(`${cid},`)) setRelatedAccessoires(relatedAccessoires.replace(`,${cid}`, ''));
        else setRelatedAccessoires(relatedAccessoires.replace(`${cid}`, ''));
    };

    const handleChange = (e) => setArticlesFill(articles.filter(({ name }) => name.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())));
    const handleChangeCodebarre = (e) => setArticlesFillCodebarre(articles.filter(({ name, category }) => category === 8 && name.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())));

    const onSubmit = async values => {
        try {
            dispatch(setLoading(true))
            const body = {
                ...values,
                web,
                booking,
                borne,
                planning,
                promotion,
                article: selectedArticle,
                color: color.hex,
                strings: JSON.stringify({ string_1: values?.topText?.replace(/\n/g, "<br/>"), string_2: values?.bottomText?.replace(/\n/g, "<br/>") }),
                colors: { primary: primaryColor, secondary: secondaryColor, background: backgroundColor },
                plannings: relatedPack,
                equipements: relatedAccessoires,
                image: `/uploads/offres/${oid}.png?cache=${new Date().getTime()}`,
                image_borne: `/uploads/offres/borne-${oid}.png?cache=${new Date().getTime()}`,
                image_ads: `/uploads/offres/ads-${oid}.png?cache=${new Date().getTime()}`,
            }

            // 👽 UPDATE IMAGE REQUEST
            if (!_.isEmpty(file)) {
                const formData = new FormData()
                formData.append('file', file)
                await AXIOS.post(`/api/v1/uploads/offres/${oid}`, formData);
            }

            // 👽 UPDATE IMAGE REQUEST
            if (!!fileBorne?.name && true) {
                console.log(fileBorne)
                const formData = new FormData()
                formData.append('file', fileBorne)
                await AXIOS.post(`/api/v1/uploads/offres/borne-${oid}`, formData);
            }

            // 👽 UPDATE IMAGE REQUEST
            if (!!fileAds?.name && true) {
                console.log('inside : ', fileAds)
                const formData = new FormData()
                formData.append('file', fileAds)
                await AXIOS.post(`/api/v1/uploads/offres/ads-${oid}`, formData);
            }

            // 👽 UPDATE OFFRE REQUEST
            await AXIOS.patch(`/api/v1/offres/${oid}`, body)
            history.push('/offres')
            dispatch(setFetch(!fetch))
            dispatch(setLoading(false))

        } catch (error) {
            console.log(error)
        }
    }

    const updateBorneSatus = () => {
        setBorne(!borne)
        // if(borne && !!planning)
        //     setPlanning(false)
    }

    return (
        <div className="gestion">
            <div className="gestion__header">
                <h4 className="gestion__title">Update offre</h4>
            </div>
            <div className="gestion__wrapper">
                <form onSubmit={handleSubmit(onSubmit)} className="form">

                    {/* :TODO: INFO */}
                    <div className="form__container" >
                        <div className="form__inputboxWrapper">
                            <Title color={'#183a68'}>Fiche offre :</Title>
                            <div className="form__inputboxWrapper" style={{ width: '100%' }}>

                                <div className="form__inputbox">
                                    <label htmlFor="name" className="form__label">Nom</label>
                                    <input name="name" defaultValue={offre?.name} onChange={e => setName(e.target.value)} ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.name && errors.name.message}
                                </div>

                                <div className="form__inputbox">
                                    <label htmlFor="birthday" className="form__label">Activité</label>
                                    <select name="aid" ref={register({ required: 'Required' })} className="form__input" style={{ padding: '0 1rem' }}>
                                        {activites.map(({ aid, name }) => <option className="form__dropdown" selected={aid === offre?.aid ? 'selected' : ''} key={aid} value={aid}>{name}</option>)}
                                    </select>
                                    {errors.aid && errors.aid.message}
                                </div>

                                <div className="form__inputbox">
                                    <label htmlFor="birthday" className="form__label">Classement</label>
                                    <input name="classement" defaultValue={offre?.classement} type="number" min="1" ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.classement.message}
                                </div>
                            </div>
                        </div>

                        <div style={{ width: '25%', height: '100%' }}>
                            <Title color={'#183a68'}>Offre démo :</Title>
                            <div className="card">
                                <Heading color={color.hex}>{name}</Heading>
                                <Picture image={imageURL ? imageURL : '/img/default_image.png'}>&nbsp;</Picture>
                            </div>
                        </div>
                    </div>

                    {/* :FIXME: IMAGE & COLOR */}
                    <div className="form__container" style={{ justifyContent: 'flex-start', marginBottom: '3rem' }}>

                        <div className="gestion__imageWrapper">
                            <label htmlFor="image" className="form__label">Importer une image</label>
                            <div {...getRootProps()} className="dropzone">
                                <input {...getInputProps()} />
                                <img src="/img/icon/upload.svg" alt="upload" style={{ width: '120px' }} />
                            </div>
                        </div>

                        <div className="gestion__colorWrapper" style={{ marginLeft: '10rem' }}>
                            <label htmlFor="color" className="form__label">Choisir un color</label>
                            <div style={{ marginTop: '1rem' }}>
                                <ChromePicker color={color} onChange={color => setColor(color)} />
                            </div>
                        </div>

                    </div>

                    <div className="text__container">
                        <div className="text__inputContainer">
                            <div className="borne__label" style={{ marginBottom: '1rem' }}>TEXTE</div>
                            <div className="">
                                <textarea
                                    name="topText"
                                    ref={register({})}
                                    className="text__input"
                                    defaultValue={strings['string_1']?.replace(/<br\s*\/?>/gi, '\n')}
                                    onChange={e => setStrings({ string_1: e.target.value, string_2: strings['string_2'] })}
                                    style={{ width: '100%', fontSize: '1.6rem', marginBottom: '1rem' }}
                                    rows="4" // Adjust the rows to set the height of the textarea
                                    placeholder="Entrez votre texte du haut ici..."
                                />
                                <textarea
                                    name="bottomText"
                                    ref={register({})}
                                    className="text__input"
                                    defaultValue={strings['string_2']?.replace(/<br\s*\/?>/gi, '\n')}
                                    onChange={e => setStrings({ string_1: strings['string_1'], string_2: e.target.value })}
                                    style={{ width: '100%', fontSize: '1.6rem' }}
                                    rows="4"
                                    placeholder="Entrez votre texte du bas ici..."
                                />
                            </div>
                        </div>
                    </div>

                    {true && <div className="borne">
                        <div className="borne__switchContainer">
                            <div className="borne__switch">
                                <div className="borne__label">site marchand</div>
                                <Switch checked={web} onColor={color.hex} onChange={() => setWeb(!web)} />
                            </div>

                            <div className="borne__switch">
                                <div className="borne__label">booking</div>
                                <Switch checked={booking} onColor={color.hex} onChange={() => setBooking(!booking)} />
                            </div>

                            <div className="borne__switch">
                                <div className="borne__label">borne</div>
                                <Switch checked={borne} onColor={color.hex} onChange={updateBorneSatus} />
                            </div>
                            <div className="borne__switch">
                                <div className="borne__label">planning</div>
                                <Switch disabled={!borne} checked={planning} onColor={color.hex} onChange={() => setPlanning(!planning)} />
                            </div>
                        </div>

                        {!!borne && <>
                            {/* :TODO: */}
                            <div className="" style={{ marginTop: '20px' }}>
                                <div className="gestion__imageWrapper">
                                    <label htmlFor="image" className="form__label">Borne</label>
                                    <div className="">
                                        <input ref={fileInputRef} type="file" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} />
                                        <img onClick={handleUploadClick} src="/img/icon/upload.svg" alt="upload" style={{ width: '40px', cursor: 'pointer' }} />
                                    </div>
                                </div>
                                <img src={imageBorne} alt="" style={{ width: '100%', marginTop: '10px' }} onError={(e) => {
                                    e.target.onerror = null; // Prevents looping
                                    e.target.src = `${process.env.REACT_APP_SITE_MARCHAND}/img/default_image_borne.png`; // Path to your default image
                                }} />
                            </div>

                            <div className="" style={{ display: 'flex', marginTop: '3rem', marginBottom: '4rem' }}>
                                <div className="" style={{ marginRight: '20px' }}>
                                    <div className="borne__label" style={{ marginBottom: '18px' }}>couleur primaire</div>
                                    <TwitterPicker color={primaryColor} onChange={({ hex }) => setPrimaryColor(hex)} colors={[primaryColor]} />
                                </div>
                                <div className="" style={{ marginRight: '20px' }}>
                                    <div className="borne__label" style={{ marginBottom: '18px' }}>couleur secondaire</div>
                                    <TwitterPicker color={secondaryColor} onChange={({ hex }) => setSecondaryColor(hex)} colors={[secondaryColor]} />
                                </div>
                                <div className="">
                                    <div className="borne__label" style={{ marginBottom: '18px' }}>couleur de fond</div>
                                    <TwitterPicker color={backgroundColor} onChange={({ hex }) => setBackgroundColor(hex)} colors={[backgroundColor]} />
                                </div>
                            </div>
                        </>}

                        {!!borne && <>
                            {/* :FIXME: */}
                            <div className="" style={{ marginTop: '20px' }}>
                                <div className="gestion__imageWrapper">
                                    <label htmlFor="image" className="form__label">recommendations</label>
                                    <div className="borne__switch" style={{ width: '250px' }}>
                                        <div className="borne__label">recommendations</div>
                                        <Switch checked={promotion} onColor={color.hex} onChange={() => setPromotion(!promotion)} />
                                    </div>
                                    <div className="">
                                        <input ref={fileInputAdsRef} type="file" accept="image/*" onChange={handleImageAdsChange} style={{ display: 'none' }} />
                                        <img onClick={handleUploadAdsClick} src="/img/icon/upload.svg" alt="upload" style={{ width: '40px', cursor: 'pointer' }} />
                                    </div>
                                </div>
                                <img src={imageAds} alt="" style={{ width: '350px', marginTop: '10px' }} />
                            </div>

                            <div className="" style={{ marginTop: '30px' }}>
                                {/*🐫👽👼 */}
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label htmlFor="birthday" className="form__label">
                                        Article V12
                                    </label>
                                    <input name="search" onChange={handleChange} placeholder="Rechercher" className="form__input  list__input" />
                                    <div className="list__wrapper">
                                        <ItemsList articles={articlesFill} selectedArticle={selectedArticle} setSelectedArticle={setSelectedArticle} />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: '53px', width: '100%' }}>
                                <div>

                                    <div className="form__inputbox" style={{ width: '410px', marginTop: '50px' }}>
                                        <label htmlFor="relatedPack" className="form__label">
                                            Plannings liés
                                        </label>
                                        <input value={relatedPackInputValue} onFocus={() => setRelatedPackInputValue('')} onChange={handleChangeRelatedPack} type="text" name="relatedPack" ref={register()} list="relatedPack" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                                        <datalist id="relatedPack">
                                            {taches
                                                .filter(({ id }) => !relatedPack?.includes(id))
                                                .map(({ id, label }) => (
                                                    <option className="form__dropdown" key={id} value={id}>
                                                        {label}
                                                    </option>
                                                ))}
                                        </datalist>
                                    </div>

                                    {relatedPack?.split(',')?.map((item, index) =>
                                        taches?.map(({ id, label }) => {
                                            if (item == id)
                                                return (
                                                    <div key={item} className="form__planningItem">
                                                        <div className="form__planningText" style={{ width: '10px', marginLeft: '12.6px' }}>
                                                            {index + 1}
                                                        </div>
                                                        <Icons color="#FF5C00" style={{ width: '3rem', height: '3rem' }}>
                                                            <use xlinkHref="/img/sprite.svg#icon-calendar"></use>
                                                        </Icons>
                                                        <div className="form__planningText">{label}</div>
                                                        <Icons onClick={() => deleteRelatedPack(id)} color="#ED292D" style={{ width: '2rem', height: '2rem', marginLeft: 'auto' }}>
                                                            <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                                        </Icons>
                                                    </div>
                                                );
                                        })
                                    )}
                                </div>

                                <div style={{ marginTop: '20px' }}>
                                    <div className="form__inputbox" style={{ width: '410px' }}>
                                        <label htmlFor="relatedAccessoires" className="form__label">
                                            Equipements
                                        </label>
                                        <input value={relatedAccessoiresInputValue} onFocus={() => setRelatedAccessoiresInputValue('')} onChange={handleChangeRelatedAccessoires} type="text" name="relatedAccessoires" ref={register()} list="relatedAccessoires" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                                        <datalist id="relatedAccessoires">
                                            {accessoires
                                                .filter(({ cid }) => !relatedAccessoires?.includes(cid))
                                                .map(({ cid, name }) => (
                                                    <option className="form__dropdown" key={cid} value={cid}>
                                                        {name}
                                                    </option>
                                                ))}
                                        </datalist>
                                    </div>
                                    {relatedAccessoires?.split(',')?.map((item, index) =>
                                        accessoires?.map(({ cid, name, image }) => {
                                            if (cid == item)
                                                return (
                                                    <div key={item} className="form__planningItem">
                                                        <div className="form__planningText" style={{ width: '10px', marginLeft: '12.6px' }}>
                                                            {index + 1}
                                                        </div>
                                                        <PictureItem image={`${process.env.REACT_APP_SITE_MARCHAND}${image}`} style={{ width: '3rem', height: '3rem', borderRadius: '3px' }}>
                                                            &nbsp;
                                                        </PictureItem>
                                                        <div className="form__planningText">{name}</div>
                                                        <Icons onClick={() => deleteRelatedAccessoires(cid)} color="#ED292D" style={{ width: '2rem', height: '2rem', marginLeft: 'auto' }}>
                                                            <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                                        </Icons>
                                                    </div>
                                                );
                                        })
                                    )}
                                </div>
                            </div>

                            <div style={{ display: 'flex', marginTop: '40px' }}>
                                <div className="form__inputbox" style={{ marginRight: '30px' }}>
                                    <label htmlFor="birthday" className="form__label">participants minimum</label>
                                    <input name="placesMin" defaultValue={offre?.placesMin} type="number" min="1" max={watch('placesMax')} ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.placesMin.message}
                                </div>
                                <div className="form__inputbox">
                                    <label htmlFor="birthday" className="form__label">participants maximum</label>
                                    <input name="placesMax" defaultValue={offre?.placesMax} type="number" min={watch('placesMin')} ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.placesMax.message}
                                </div>
                            </div>

                        </>}

                    </div>}

                    {/* :FIXME: BUTTON */}
                    <div className="gestion__buttonWrapper" style={{ marginTop: '20px' }}>
                        <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#0D53FC' }}>Update</button>
                        <Link to='/offres'>
                            <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#fc114c' }}>Fermer</button>
                        </Link>
                    </div>

                </form>
            </div>
        </div>
    );
}

export default UpdateOffre